import { useEffect, useState } from 'react';
import { PERMISSION, PERMISSIONS } from '../constants/permissionConstants';
import { usePermissionsHandler } from './usePermissions';
import {
  selectDefaultPaymentMethod,
  subscriptionActions,
  selectUserActivePlanDetails,
  selectUserPlanList,
  setContactFormDialogOpen,
  selectPlanUpgradedFlag,
  selectPlanList,
  selectPurchasedUploadLimitPlanListSelector,
  selectBillingInfo,
  selectSegmentDataForBilling,
  selectGetCardList,
  selectCartAddonsList,
  selectIsCreatorPlan,
  selectAllCustomProductsUsedCount,
  selectAllPurchasedPlanListSelector,
  selectImagineCreditLimit,
} from '../redux/slicers/subscriptionSlicer';
import { useDispatch, useSelector } from 'react-redux';
import { errorToast, infoToast } from '../helpers/toastHelper';
import {
  apiToCancelOrRestoreActiveClientSubscription,
  apiToCancelOrRestoreActiveClientSubscriptionV2,
  BuyOneTimeAddOnPlan,
  DowngradeMissingFeatureList,
  DowngradeToNewPlan,
  DowngradeToNewPlanV2,
  getImagineCreditCount,
  removeAllItemsFromCart,
  setClientSubscriptionPlans,
  setClientSubscriptionPlansV2,
  setCustomProductsUsedCount,
  setFailedClientSubscriptionPlansAndAddOns,
  setFailedClientSubscriptionPlansAndAddOnsV2,
  setMainSubscriptionPlans,
  UpgradeToNewPlan,
  UpgradeToNewPlanPatch,
  UpgradeToNewPlanPatchV2,
  UpgradeToNewPlanV2,
} from '../api/subscription/subscription';
import {
  ADD_ONS_PRODUCT_BASE_NAME,
  CHECKOUT_ADD_PAYMENT_METHOD_POPUP_FORM,
  filterOutMissingFeatureList,
  getDateFromTimestamp,
  navigateToPlans,
  PAYMENT_METHOD_TYPE,
  RECURRING_INTERVAL,
  RECURRING_INTERVAL_INFO,
} from '../screens/subscriptionComponents/subscriptionHelper';
import { useStripe } from '@stripe/react-stripe-js';
import { useInfoDialogaActions } from './useInfoDialogaActions';
import InfoDialogUI from '../components/InfoDialog/InfoDialogUI';
import { useUserContext } from '../contexts/UserContext';
import { gamifyBoardingActions } from '../redux/slicers/gamifySlicer';
import {
  getLocalStorage,
  removeLocalStorage,
  removeUndefinedText,
  wait,
  windowOpen,
} from '../helpers/jsHelper';
import { IS_GAMIFIED_SKIP } from '../constants/projectConstants';
import Button from '../components/Button';
import { CloseIcon } from '../components/icons/CloseIcon';
import SubscriptionStatusModal from '../screens/subscriptionComponents/SubscriptionStatusModal';
import { WHY_DOWNGRADING_OPTIONS } from '../screens/Plans';
import { HUBSPOT_API } from '../helpers/api';
import PaymentDoneIcon from '../components/icons/PaymentDone';
import { Input } from '../common';
import Loader from '../components/Loader/Loader';
import { history } from '../history';
import { callTrackEvent } from '../helpers/segmentHelper';
import { getAppState } from '../redux/store';
import {
  MATTRESS_BUILDER_BASE_TYPE,
  TEXTURE_BASE_TYPE,
  THREE_3D_MODAL_BASE_TYPE,
} from '../constants/constants';
import { handleAddonsPurchaseResponse } from './useAddOnsInfo';
import { userPilotEvents } from '../common/Userpilot/userpilotHelper';
//import { captureException } from '@sentry/react';

var isPaymentInitiated = false;
let interval = null;

export default function useSubscriptionPurchase(props) {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const activePlan = useSelector(selectUserActivePlanDetails);
  const allMainPlanList = useSelector(selectPlanList);
  const purchasedUploadLimitPlan = useSelector(selectPurchasedUploadLimitPlanListSelector);
  const manuallyAddedItems = useSelector(selectAllCustomProductsUsedCount);
  const allPurchasePlan = useSelector(selectAllPurchasedPlanListSelector);
  const activePlanId = activePlan?.id;
  const activePlanName = activePlan?.plan_details?.[0]?.plan_name;
  const isActivePlanCancelAtPeriodEnd = activePlan?.cancel_at_period_end;
  const defaultPaymentMethod = useSelector(selectDefaultPaymentMethod);
  const imagineCreditLimit = useSelector(selectImagineCreditLimit);
  const getUserPlans = useSelector(selectUserPlanList);
  const userPlans = getUserPlans?.filter((a) => !a.is_cancelled);
  const { handlePermissionEvent } = usePermissionsHandler();
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const { currentUser, updateUserData } = useUserContext();
  const currentOrg = currentUser?.organization;

  const isBankDefaultPM =
    defaultPaymentMethod?.payment_type?.toLowerCase() === PAYMENT_METHOD_TYPE.US_BANK_ACCOUNT;
  const { upgrade: isPlanUpgraded, downgrade: isPlanDowngraded } =
    useSelector(selectPlanUpgradedFlag);

  const [missingFeature, setMissingFeature] = useState([]);
  const [loading, setLoading] = useState(false);
  const [whyDowngrading, setWhyDowngrading] = useState('');
  const [downgradingReason, setDowngradingReason] = useState('');
  const [showWhyDowngradingModal, setShowWhyDowngradingModal] = useState(false);
  // const [upgrade, setUpgrade] = useState(null);
  const [downgradePlan, setDowngradePlan] = useState(null);
  const [featureLoading, setFeatureLoading] = useState(false);
  const [checkoutInfo, setCheckoutInfo] = useState(null);
  const [billingCycle, setBillingCycle] = useState(RECURRING_INTERVAL.MONTH);
  const [restorePlanLoading, setRestorePlanLoading] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const wuSelectedPlanPriceId = searchParams.get('selectedPlanPriceId') || '';
  const backToReferrerUrl = searchParams.get('referrer')?.replace(window.location.origin, '') || window.referrer;
  const uploadLimitPlan = allMainPlanList?.filter(
    ({ is_upload_limit_plan }) => is_upload_limit_plan
  );

  const getEditorParam = () => {
    // here, we get the editos in params when user redirected from the Editor Nudge modal
    const e = searchParams.get('editors');
    return e ? parseInt(e) : null;
  };

  const { trackClickEvent } = userPilotEvents();

  const { results: cartAddonsList } = useSelector(selectCartAddonsList);

  const [pricingDetails, setPricingDetails] = useState(null);
  const [originPrices, setOriginPrices] = useState({
    [THREE_3D_MODAL_BASE_TYPE]: '',
    [TEXTURE_BASE_TYPE]: '',
    [ADD_ONS_PRODUCT_BASE_NAME.Editor]: '',
  });
  const [sliderValues, setSliderValues] = useState({
    [ADD_ONS_PRODUCT_BASE_NAME.Editor]: getEditorParam() || 1,
    [THREE_3D_MODAL_BASE_TYPE]: 0,
    [TEXTURE_BASE_TYPE]: 0,
  });
  const [isMattressBuilderPurchased, setIsMattressBuilderPurchased] = useState(null);

  useEffect(() => {
    dispatch(setCustomProductsUsedCount());
  }, []);

  useEffect(() => {
    if(!imagineCreditLimit?.length && props?.imagineCredit){
      getImagineCreditInfo()
    }
  }, []);

  useEffect(() => {
    manageMattressBuilderAvailability();
  }, [userPlans, manuallyAddedItems]);

  const getImagineCreditInfo = async () => {
    const res = await getImagineCreditCount()
    dispatch(subscriptionActions.setImagineCreditLimit(res?.results || []));
    return res?.results || [] 
  }

  const manageMattressBuilderAvailability = () => {
    if (userPlans?.length || manuallyAddedItems?.length || allPurchasePlan?.length) {
      const includesMattressBuilder = (plans) =>
        plans?.some(({ plan_details }) =>
          plan_details?.some(({ basemodeltype }) => basemodeltype === MATTRESS_BUILDER_BASE_TYPE)
        );
      // Check if any purchase plan includes the mattress builder base type
      const activePlanOnly = allPurchasePlan?.filter(
        ({ is_cancelled, status }) => !is_cancelled && status !== 'deleted'
      );
      const hasMattressBuilderAllPlan = includesMattressBuilder(activePlanOnly);
      // Filter active plans that are not cancelled or deleted
      const activePlans = userPlans?.filter(
        ({ is_cancelled, status }) => !is_cancelled && status !== 'deleted'
      );
      // Check if any active plan includes the mattress builder base type
      const hasMattressBuilder = includesMattressBuilder(activePlans);
      // Check if any manually added item includes the mattress builder base type
      const hasMattressBuilderFromDashboard = manuallyAddedItems?.some(
        ({ basemodeltype }) => basemodeltype === MATTRESS_BUILDER_BASE_TYPE
      );
      setIsMattressBuilderPurchased(
        hasMattressBuilderAllPlan || hasMattressBuilder || hasMattressBuilderFromDashboard
      );
    } else if (isMattressBuilderPurchased) {
      setIsMattressBuilderPurchased(false);
    }
  };

  useEffect(() => {
    if (currentUser) setCheckoutInfo(null);
  }, [currentUser?.organization]);

  useEffect(() => {
    if (checkoutInfo) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'auto';
  }, [checkoutInfo]);

  const closeDowngradingReasonModal = () => {
    setWhyDowngrading('');
    setDowngradingReason('');
    setShowWhyDowngradingModal(false);
  };

  const closeDialog = async () => {
    dispatch(subscriptionActions.setPlanDetailsLoading(true));
    dispatch(setClientSubscriptionPlans());
    dispatch(setFailedClientSubscriptionPlansAndAddOns());
    dispatch(subscriptionActions.setBrowsePlans(false));
    dispatch(subscriptionActions.PlanUpgraded({ upgrade: false, downgrade: false }));
    setDowngradePlan(null);
    setMissingFeature([]);
    setLoading(false);
    // closeInfoDialog();

    if (backToReferrerUrl) {
      if (window.referrer) window.referrer = null;
      windowOpen(decodeURI(backToReferrerUrl));
    }

    dispatch(setMainSubscriptionPlans());
    closeDowngradingReasonModal();

    updateUserData();

    // const isGamifiedSkip = getLocalStorage(IS_GAMIFIED_SKIP, true);
    // if (isGamifiedSkip) {
    //   await wait(6000);
    //   removeLocalStorage(IS_GAMIFIED_SKIP);
    //   dispatch(gamifyBoardingActions.openGamifiedDialog(true));
    // }
  };

  const closeDowngradeModal = () => {
    setDowngradePlan(null);
    setMissingFeature([]);
    setLoading(false);
    closeDowngradingReasonModal();
    dispatch(subscriptionActions.PlanUpgraded({ upgrade: false, downgrade: false }));
  };

  const contactSupport = () => {
    setDowngradePlan(null);
    dispatch(setContactFormDialogOpen(true));
  };

  const addDataToSegment = () => {
    const { billing_name, billing_country, billing_email, billing_pincode, billing_address } =
      selectBillingInfo(getAppState());
    const segmentData = selectSegmentDataForBilling(getAppState());
    const allBankDetails = selectGetCardList(getAppState());
    const copyData = JSON.parse(JSON.stringify(segmentData));
    const dataForSegment = {
      Full_Name: billing_name || '',
      Billing_Email_Address: billing_email || '',
      Country: billing_country || '',
      PinCode: billing_pincode || '',
      Payment_Method: defaultPaymentMethod?.payment_type || '',
      // Account: allBankDetails?.results?.[0]?.account_number || '',
      // Card_number: allBankDetails?.results?.[0]?.last4 || '',
      // Billing_name: billing_name || '',
      // Billing_address: billing_address || '',
      ...copyData,
    };
    delete dataForSegment['Modification'];
    callTrackEvent('Payment success subscription', dataForSegment, true);
  };

  const handleUpgradePlanAPI = async ({ billingInterval, callback }) => {
    if (!checkoutInfo) return;
    const typeValue = billingInterval || billingCycle;
    let planDetails = checkoutInfo?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) =>
        +typeValue === 1
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '1' // Monthly
          : +typeValue === 2
            ? +recurring_interval === 2 && recurring_interval_count?.toString() === '1' // Yearly
            : +typeValue === 3
              ? +recurring_interval === 1 && recurring_interval_count?.toString() === '3' // Quarterly
              : +typeValue === 4
                ? +recurring_interval === 1 && recurring_interval_count?.toString() === '6' // Semi annually
                : null
    );
    let payload = {
      stripe_price_id: JSON.stringify([{ price: planDetails?.stripe_price_id, quantity: '1' }]),
      paymentMethodId: defaultPaymentMethod?.stripe_payment_method_id,
      collection_method: 'charge_automatically',
      is_upgraded_plan: true,
      recurring_interval: RECURRING_INTERVAL_INFO?.[+typeValue]?.interval,
      recurring_interval_count: RECURRING_INTERVAL_INFO?.[+typeValue]?.count,
      is_texture_plan: false,
      ...(activePlanId ? { main_plan_modify: true } : {}),
    };
    if (!userPlans?.length) {
      delete payload.is_upgraded_plan;
    }

    // this is temporary solution for testing
    const api = activePlanId ? UpgradeToNewPlanPatch : UpgradeToNewPlan;

    setLoading(true);
    // UpgradeToNewPlan(payload)
    // UpgradeToNewPlanPatch(926, payload);
    api(payload, activePlanId)
      .then(async (response) => {
        if (response?.data?.SCA && response?.data?.client_secret) {
          const savedDefaultPM = defaultPaymentMethod?.stripe_payment_method_id;
          const paymentIntentClientSecret = response?.data?.client_secret;

          await stripe
            .confirmPayment({
              clientSecret: paymentIntentClientSecret,
              confirmParams: {
                payment_method: savedDefaultPM,
                return_url: window.location.href,
              },
              redirect: 'if_required',
            })
            .then(({ error, paymentIntent }) => {
              if (error) {
                if (
                  error.param === 'mandate_data' &&
                  error.payment_intent.status === 'processing'
                ) {
                  infoToast('Your payment is currently being processed.');
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                } else if (error.payment_intent?.status === 'requires_payment_method') {
                  errorToast(error.message || 'Please add payment method.');
                } else if (error.payment_intent?.status === 'canceled') {
                  // dispatcher(setFailedClientSubscriptionPlansAndAddOns());
                  // dispatcher(setClientSubscriptionPlans());
                  errorToast('Your payment is cancelled.');
                } else {
                  if (error.payment_intent?.status === 'processing') {
                    infoToast('Your payment is currently under processing.');
                    dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                  } else {
                    dispatch(subscriptionActions.PlanUpgraded({ upgrade: false }));
                    errorToast(error.message || 'Something went wrong. Please try again later.');
                  }
                }
              } else {
                addDataToSegment();
                if (paymentIntent?.status === 'succeeded') {
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                } else if (paymentIntent?.status === 'processing') {
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                  infoToast('Your payment is currently under processing.');
                }
              }
            });
        } else {
          addDataToSegment();
          dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
        }
      })
      .catch((error) => {
        errorToast(error?.message || 'Something went wrong. Please try again!');
      })
      .finally(() => {
        setLoading(false);
        // callback?.();
      });
  };

  const handleUpgradePlanAPIV2 = async ({ billingInterval, callback, payload: data }) => {
    if (!checkoutInfo) return;
    const typeValue = billingInterval || billingCycle;
    let planDetails = data
      ? data
      : checkoutInfo?.pricing_details?.find(({ recurring_interval, recurring_interval_count }) =>
        +typeValue === 1
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '1' // Monthly
          : +typeValue === 2
            ? +recurring_interval === 2 && recurring_interval_count?.toString() === '1' // Yearly
            : +typeValue === 3
              ? +recurring_interval === 1 && recurring_interval_count?.toString() === '3' // Quarterly
              : +typeValue === 4
                ? +recurring_interval === 1 && recurring_interval_count?.toString() === '6' // Semi annually
                : null
      );
    // let payload = {
    //   stripe_price_id: JSON.stringify([{ price: planDetails?.stripe_price_id, quantity: '1' }]),
    //   paymentMethodId: defaultPaymentMethod?.stripe_payment_method_id,
    //   collection_method: 'charge_automatically',
    //   is_upgraded_plan: true,
    //   recurring_interval: RECURRING_INTERVAL_INFO?.[+typeValue]?.interval,
    //   recurring_interval_count: RECURRING_INTERVAL_INFO?.[+typeValue]?.count,
    //   is_texture_plan: false,
    //   ...(activePlanId ? { main_plan_modify: true } : {}),
    // };
    let payload = {
      recurring_prices: [{ price_id: planDetails?.stripe_price_id, quantity: '1' }],
      paymentMethodId: defaultPaymentMethod?.stripe_payment_method_id,
      collection_method: 'charge_automatically',
      recurring_interval: RECURRING_INTERVAL_INFO?.[+typeValue]?.interval,
      recurring_interval_count: RECURRING_INTERVAL_INFO?.[+typeValue]?.count,
      is_texture_plan: false,
      ...data,
    };
    if (!userPlans?.length) {
      delete payload.is_upgraded_plan;
    }

    if (activePlanId) {
      delete payload.is_texture_plan;
      payload.add_subscription_items = true;
    }

    let createNewSubscription = userPlans?.find(
      ({ recurring_interval }) => +recurring_interval === typeValue
    );
    if (typeValue !== activePlan?.recurring_interval && !createNewSubscription) {
      createNewSubscription = true;
    }
    let res = null;

    const api =
      createNewSubscription === true
        ? UpgradeToNewPlanV2
        : activePlanId
          ? UpgradeToNewPlanPatchV2
          : UpgradeToNewPlanV2;

    setLoading(true);
    // UpgradeToNewPlan(payload)
    // UpgradeToNewPlanPatch(926, payload);
    api(payload, createNewSubscription?.id || activePlanId)
      .then(async (response) => {
        res = response;
        if (response?.data?.SCA && response?.data?.client_secret) {
          const savedDefaultPM = defaultPaymentMethod?.stripe_payment_method_id;
          const paymentIntentClientSecret = response?.data?.client_secret;

          await stripe
            .confirmPayment({
              clientSecret: paymentIntentClientSecret,
              confirmParams: {
                payment_method: savedDefaultPM,
                return_url: window.location.href,
              },
              redirect: 'if_required',
            })
            .then(({ error, paymentIntent }) => {
              if (error) {
                if (
                  error.param === 'mandate_data' &&
                  error.payment_intent.status === 'processing'
                ) {
                  infoToast('Your payment is currently being processed.');
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                } else if (error.payment_intent?.status === 'requires_payment_method') {
                  errorToast(error.message || 'Please add payment method.');
                } else if (error.payment_intent?.status === 'canceled') {
                  // dispatcher(setFailedClientSubscriptionPlansAndAddOns());
                  // dispatcher(setClientSubscriptionPlans());
                  errorToast('Your payment is cancelled.');
                } else {
                  if (error.payment_intent?.status === 'processing') {
                    infoToast('Your payment is currently under processing.');
                    dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                  } else {
                    dispatch(subscriptionActions.PlanUpgraded({ upgrade: false }));
                    errorToast(error.message || 'Something went wrong. Please try again later.');
                  }
                }
              } else {
                addDataToSegment();
                if (paymentIntent?.status === 'succeeded') {
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                } else if (paymentIntent?.status === 'processing') {
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                  infoToast('Your payment is currently under processing.');
                }
              }
            });
        } else {
          if (res) {
            addDataToSegment();
            dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
          }
        }
        setLoading(false);
      })
      .catch((error) => {
        errorToast(error?.message || 'Something went wrong. Please try again!');
      })
      .finally(() => {
        setLoading(false);
        if (data) {
          callback?.(res);
        }
      });
  };

  const handleDowngradePlanAPI = async ({ billingInterval, callback }) => {
    if (isActivePlanCancelAtPeriodEnd && activePlanId) {
      await apiToCancelOrRestoreActiveClientSubscription({
        id: activePlanId,
        cancel_at_period_end: false,
        successMessage: null,
      })
        .then(() => { })
        .finally(() => {
          dispatch(setClientSubscriptionPlans());
          setLoading(false);
          // callback?.();
        });
    }

    const typeValue = billingInterval || billingCycle;

    const planDetails = downgradePlan?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) =>
        +typeValue === 1
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '1' // Monthly
          : +typeValue === 2
            ? +recurring_interval === 2 && recurring_interval_count?.toString() === '1' // Yearly
            : +typeValue === 3
              ? +recurring_interval === 1 && recurring_interval_count?.toString() === '3' // Quarterly
              : +typeValue === 4
                ? +recurring_interval === 1 && recurring_interval_count?.toString() === '6' // Semi annually
                : null
    );
    const payload = {
      downgraded_plan_id: planDetails?.stripe_price_id,
      is_subscription_schedule: true,
      collection_method: 'charge_automatically',
      paymentMethodId: defaultPaymentMethod?.stripe_payment_method_id,
      is_texture_plan: false,
    };
    const res = await dispatch(DowngradeToNewPlan(payload, activePlan?.id));
    if (!res || res) {
      setLoading(false);
    }
  };

  const handleDowngradePlanAPIV2 = async ({ billingInterval, callback }) => {
    if (isActivePlanCancelAtPeriodEnd && activePlanId) {
      await apiToCancelOrRestoreActiveClientSubscription({
        id: activePlanId,
        cancel_at_period_end: false,
        successMessage: null,
      })
        .then(() => { })
        .finally(() => {
          dispatch(setClientSubscriptionPlans());
          setLoading(false);
          // callback?.();
        });
    }

    const typeValue = billingInterval || billingCycle;

    const planDetails = downgradePlan?.pricing_details?.find(
      ({ recurring_interval, recurring_interval_count }) =>
        +typeValue === 1
          ? +recurring_interval === 1 && recurring_interval_count?.toString() === '1' // Monthly
          : +typeValue === 2
            ? +recurring_interval === 2 && recurring_interval_count?.toString() === '1' // Yearly
            : +typeValue === 3
              ? +recurring_interval === 1 && recurring_interval_count?.toString() === '3' // Quarterly
              : +typeValue === 4
                ? +recurring_interval === 1 && recurring_interval_count?.toString() === '6' // Semi annually
                : null
    );
    const payload = {
      downgraded_plan_id: planDetails?.stripe_price_id,
      is_subscription_schedule: true,
      collection_method: 'charge_automatically',
      paymentMethodId: defaultPaymentMethod?.stripe_payment_method_id,
      is_texture_plan: false,
    };
    const res = await dispatch(DowngradeToNewPlanV2(payload, activePlan?.id));
    if (!res || res) {
      setLoading(false);
    }
  };

  const handleUpgrade = ({
    billingInterval,
    isDowngrading = false,
    skipCard = false,
    callback,
  }) => {
    if (isPaymentInitiated) return;
    isPaymentInitiated = true;
    setShowWhyDowngradingModal(false);

    setLoading(true);

    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          if (defaultPaymentMethod || skipCard) {
            dispatch(subscriptionActions.setMakeCheckoutAPICall(null));
            if (isDowngrading) handleDowngradePlanAPI({ billingInterval, callback });
            else handleUpgradePlanAPI({ billingInterval, callback });
          } else {
            dispatch(subscriptionActions.setShowCardForm(true));
            dispatch(
              subscriptionActions.setMakeCheckoutAPICall(CHECKOUT_ADD_PAYMENT_METHOD_POPUP_FORM)
            );
            setLoading(false);
          }
          isPaymentInitiated = false;
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  const handleUpgradeV2 = ({
    billingInterval,
    isDowngrading = false,
    skipCard = false,
    callback,
    payload,
  }) => {
    if (isPaymentInitiated) return;
    isPaymentInitiated = true;
    setShowWhyDowngradingModal(false);

    setLoading(true);

    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          if (defaultPaymentMethod || skipCard) {
            dispatch(subscriptionActions.setMakeCheckoutAPICall(null));
            if (isDowngrading) handleDowngradePlanAPIV2({ billingInterval, callback });
            else handleUpgradePlanAPIV2({ billingInterval, callback, payload });
          } else {
            dispatch(subscriptionActions.setShowCardForm(true));
            dispatch(
              subscriptionActions.setMakeCheckoutAPICall(CHECKOUT_ADD_PAYMENT_METHOD_POPUP_FORM)
            );
            setLoading(false);
          }
          isPaymentInitiated = false;
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  // this function is used to buy the combination of the plan & the addons ( one time for now )
  // this will run once only when the user is on Freemium
  const handlePurchasePlanAndAddons = ({
    finalCheckoutInfo,
    billingInterval,
    callback,
    payload: data,
    isHubSpotItem,
  }) => {
    if (!finalCheckoutInfo) return;
    const typeValue = billingInterval || billingCycle;

    const _recurringAddonCheckoutInfo = finalCheckoutInfo?.addonCheckoutInfo?.filter(
      (a) =>
        !a.is_one_time && !a.is_archived && a?.basemodeltype !== ADD_ONS_PRODUCT_BASE_NAME.Editor
    );
    let recurringAddonPriceId = [];
    if (_recurringAddonCheckoutInfo?.length > 0) {
      if (!isHubSpotItem) {
        _recurringAddonCheckoutInfo?.map((info) => {
          let monthlyPlan = info?.prices.find(({ recurring_interval, recurring_interval_count }) =>
            +typeValue === 1
              ? +recurring_interval === 1 && recurring_interval_count?.toString() === '1' // Monthly
              : +typeValue === 2
                ? +recurring_interval === 2 && recurring_interval_count?.toString() === '1' // Yearly
                : +typeValue === 3
                  ? +recurring_interval === 1 && recurring_interval_count?.toString() === '3' // Quarterly
                  : +typeValue === 4
                    ? +recurring_interval === 1 && recurring_interval_count?.toString() === '6' // Semi annually
                    : null
          );
          if (monthlyPlan) {
            recurringAddonPriceId.push({
              price_id: monthlyPlan?.stripe_price_id,
              quantity: info?.quantity,
            });
          }
        });
      } else {
        // subscriptionAvailable = hubSpotItems?.parent?.id ? { id: hubSpotItems?.parent?.id } : null;
        recurringAddonPriceId.push({
          price_id: isHubSpotItem?.actualValue?.price_stripe_price_id,
          quantity: isHubSpotItem?.count,
        });
      }
    }

    const _oneTimeAddonCheckoutInfo = finalCheckoutInfo?.addonCheckoutInfo?.filter(
      (a) => a.is_one_time && !a.is_archived
    );
    let oneTimeAddonPriceId = [];
    if (_oneTimeAddonCheckoutInfo?.length > 0) {
      if (!isHubSpotItem) {
        _oneTimeAddonCheckoutInfo?.map((info) => {
          let oneTimeAddonsPlan =
            info?.prices?.find(({ recurring_interval, recurring_interval_count }) =>
              +typeValue === 1
                ? recurring_interval === 1 && recurring_interval_count?.toString() === '1' // Monthly
                : +typeValue === 2
                  ? recurring_interval === 2 && recurring_interval_count?.toString() === '1' // Yearly
                  : +typeValue === 3
                    ? recurring_interval === 1 && recurring_interval_count?.toString() === '3' // Quarterly
                    : +typeValue === 4
                      ? recurring_interval === 1 && recurring_interval_count?.toString() === '6' // Semi annually
                      : null
            ) || info?.prices?.[0];
          if (oneTimeAddonsPlan) {
            oneTimeAddonPriceId.push({
              price_id: oneTimeAddonsPlan?.stripe_price_id,
              quantity: info?.quantity,
            });
          }
        });
      } else {
        oneTimeAddonPriceId.push({
          price_id: isHubSpotItem?.actualValue?.price_stripe_price_id,
          quantity: isHubSpotItem?.count,
        });
      }
    }
    // In some cases, cart items are not being removed from the cart correctly, causing outdated cart values to be sent to the API.
    // This fix has been added to prevent such issues.
    // Once the backend resolves this issue, this fix can be removed.

    const priceDetails = window.$isAddToPlanClicked ? window.$priceDetails || {} : {};

    let payload = {
      paymentMethodId: defaultPaymentMethod?.stripe_payment_method_id,
      collection_method: 'charge_automatically',
      recurring_interval: RECURRING_INTERVAL_INFO?.[+typeValue]?.interval,
      recurring_interval_count: RECURRING_INTERVAL_INFO?.[+typeValue]?.count,
      is_texture_plan: false,
      one_time_items: oneTimeAddonPriceId,
      upload_limit_prices: [],
      recurring_prices: recurringAddonPriceId,
      ...data,
    };

    const savedDefaultPM = defaultPaymentMethod?.stripe_payment_method_id;

    const cartList = cartAddonsList?.map((a) => a?.subscription_price);

    Object.keys(priceDetails)?.forEach((key) => {
      if (!priceDetails[key]) return;

      if (!cartList?.includes(priceDetails?.[key]?.product)) return;

      if (key === TEXTURE_BASE_TYPE || key === THREE_3D_MODAL_BASE_TYPE) {
        payload.upload_limit_prices.push({
          price_id: priceDetails[key]?.stripe_price_id,
          quantity: 1,
          product_type: priceDetails[key]?.productType,
        });
      }
      if (key === ADD_ONS_PRODUCT_BASE_NAME.Editor) {
        payload.recurring_prices.push({
          price_id: priceDetails[key]?.stripe_price_id,
          quantity: priceDetails[key]?.qty || 1,
        });
      }
    });

    if (!userPlans?.length) {
      delete payload.is_upgraded_plan;
    }

    if (activePlanId) {
      delete payload.is_texture_plan;
      payload.add_subscription_items = true;
    }

    // getting the active plan id basded on the selected interval
    const _activePlan = userPlans?.find(
      ({ recurring_interval }) => +recurring_interval === typeValue
    );
    const _activePlanId = _activePlan?.id;

    const buyOnlyOneTimeAddons =
      payload?.recurring_prices?.length === 0 && payload?.upload_limit_prices?.length === 0;
    let api = _activePlanId ? UpgradeToNewPlanPatchV2 : UpgradeToNewPlanV2;

    // using the old one time buy addons api to purchase addons
    // as we have not added the Models, Textures & Editors in the cart
    if (buyOnlyOneTimeAddons) {
      oneTimeAddonPriceId = oneTimeAddonPriceId.map((a) => {
        return {
          quantity: a?.quantity,
          price: a?.price_id || a?.price,
        };
      });

      payload = {
        stripe_price_id: JSON.stringify(oneTimeAddonPriceId),
        currency: 'usd',
        collection_method: 'charge_automatically',
        organization: currentOrg,
      };
      api = BuyOneTimeAddOnPlan;
    }

    setLoading(true);
    // UpgradeToNewPlan(payload)
    // UpgradeToNewPlanPatch(926, payload);
    api(payload, _activePlanId)
      .then(async (response) => {
        if (buyOnlyOneTimeAddons) {
          return await handleAddonsPurchaseResponse({
            stripe,
            response,
            savedDefaultPM,
            backToReferrerUrl,
          });
        }

        if (response?.data?.SCA && response?.data?.client_secret) {
          const paymentIntentClientSecret = response?.data?.client_secret;

          await stripe
            .confirmPayment({
              clientSecret: paymentIntentClientSecret,
              confirmParams: {
                payment_method: savedDefaultPM,
                return_url: window.location.href,
              },
              redirect: 'if_required',
            })
            .then(({ error, paymentIntent }) => {
              if (error) {
                if (
                  error.param === 'mandate_data' &&
                  error.payment_intent.status === 'processing'
                ) {
                  infoToast('Your payment is currently being processed.');
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                } else if (error.payment_intent?.status === 'requires_payment_method') {
                  errorToast(error.message || 'Please add payment method.');
                } else if (error.payment_intent?.status === 'canceled') {
                  // dispatcher(setFailedClientSubscriptionPlansAndAddOns());
                  // dispatcher(setClientSubscriptionPlans());
                  errorToast('Your payment is cancelled.');
                } else {
                  if (error.payment_intent?.status === 'processing') {
                    infoToast('Your payment is currently under processing.');
                    dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                  } else {
                    dispatch(subscriptionActions.PlanUpgraded({ upgrade: false }));
                    errorToast(error.message || 'Something went wrong. Please try again later.');
                  }
                }
              } else {
                addDataToSegment();
                if (paymentIntent?.status === 'succeeded') {
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                } else if (paymentIntent?.status === 'processing') {
                  dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
                  infoToast('Your payment is currently under processing.');
                }
              }
            });
        } else {
          if (response) {
            addDataToSegment();
            dispatch(subscriptionActions.PlanUpgraded({ upgrade: true }));
          }
        }

        if (response) {
          removeAllItemsFromCart();
        }
      })
      .catch((error) => {
        errorToast(error?.message || 'Something went wrong. Please try again!');
      })
      .finally(() => {
        setLoading(false);
        // callback?.();
      });
  };

  const handleUpgradeV3 = ({
    finalCheckoutInfo,
    billingInterval,
    isDowngrading = false,
    skipCard = false,
    callback,
    payload,
  }) => {
    if (isPaymentInitiated) return;
    isPaymentInitiated = true;
    setShowWhyDowngradingModal(false);

    setLoading(true);

    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          if (defaultPaymentMethod || skipCard) {
            dispatch(subscriptionActions.setMakeCheckoutAPICall(null));
            if (isDowngrading) handleDowngradePlanAPIV2({ billingInterval, callback });
            else
              handlePurchasePlanAndAddons({
                finalCheckoutInfo,
                billingInterval,
                callback,
                payload,
              });
          } else {
            dispatch(subscriptionActions.setShowCardForm(true));
            dispatch(
              subscriptionActions.setMakeCheckoutAPICall(CHECKOUT_ADD_PAYMENT_METHOD_POPUP_FORM)
            );
            setLoading(false);
          }
          isPaymentInitiated = false;
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  const cancelCurrentPlan = async (args) => {
    const { callback } = args || {};
    if (!activePlanId) return;
    // setCancelLoading(true);
    await apiToCancelOrRestoreActiveClientSubscription({
      id: activePlanId,
      cancel_at_period_end: true,
      successMessage: 'Your plan will be cancelled at the end of its period.',
    })
      .then((response) => {
        if (response?.id) callback?.();
      })
      .finally(() => {
        closeInfoDialog();
        dispatch(setClientSubscriptionPlans());
        // setCancelLoading(false);
      });
  };

  const cancelCurrentPlanV2 = async (args) => {
    const { callback } = args || {};
    const getActivePlanId = (plans, interval) =>
      plans?.find(
        ({ recurring_interval, is_cancelled, cancel_at_period_end }) =>
          !cancel_at_period_end && !is_cancelled && +recurring_interval === interval
      )?.id;

    const activePlanId =
      getActivePlanId(userPlans, RECURRING_INTERVAL.YEAR) ||
      getActivePlanId(userPlans, RECURRING_INTERVAL.MONTH);
    if (!activePlanId) return;
    // setCancelLoading(true);
    await apiToCancelOrRestoreActiveClientSubscriptionV2({
      id: activePlanId,
      cancel_at_period_end: true,
      successMessage: 'Your plan will be cancelled at the end of its period.',
    })
      .then((response) => {
        if (response?.id) callback?.(response?.id);
      })
      .catch(() => {
        callback?.();
      })
      .finally(() => {
        // closeInfoDialog();
        dispatch(setClientSubscriptionPlansV2());
        // setCancelLoading(false);
      });
  };

  const handleCancelPlan = (args = {}) => {
    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          openInfoDialog({
            title: 'Attention!!!',
            description:
              'Are you sure that you want to cancel the current subscription plan? Please be aware that by doing so, you will lose access to all ongoing features and benefits associated with your subscription.',
            cancelButtonText: "Don't cancel",
            buttonText: `Cancel ${activePlanName}`,
            onButtonClick: () => cancelCurrentPlan(args),
            open: true,
          });
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  const handleCancelPlanV2 = (args = {}) => {
    handlePermissionEvent(
      PERMISSION.SUBSCRIPTION,
      (r) => {
        if (r === undefined) {
          if (args?.functionCallOnly) {
            cancelCurrentPlanV2(args);
            return;
          }

          openInfoDialog({
            title: 'Attention!!!',
            description:
              'Are you sure that you want to cancel the current subscription plan? Please be aware that by doing so, you will lose access to all ongoing features and benefits associated with your subscription.',
            cancelButtonText: 'Cancel',
            buttonText: 'Confirm', // `Cancel ${activePlanName}`,
            onButtonClick: () => cancelCurrentPlanV2(args),
            open: true,
          });
        }
      },
      PERMISSIONS.SUBSCRIPTION.warningMessage
    )();
  };

  const getMissingFeature = async (info = null) => {
    if (featureLoading) return;
    const dplan = info || downgradePlan;
    const intervalData = billingCycle;
    if (intervalData) {
      const priceId = wuSelectedPlanPriceId
        ? dplan?.pricing_details?.find(
          ({ recurring_interval, id }) =>
            +recurring_interval === +intervalData &&
            id?.toString() === wuSelectedPlanPriceId?.toString()
        )
        : dplan?.pricing_details?.find(
          ({ recurring_interval }) => +recurring_interval === +intervalData
        );
      if (priceId && priceId?.id) {
        setFeatureLoading(true);
        const res = await DowngradeMissingFeatureList(`?downgrade_plan_id=${+priceId?.id}`);
        setFeatureLoading(false);
        setMissingFeature(res?.data || res || []);
      }
    }
  };

  useEffect(() => {
    if (downgradePlan && billingCycle && missingFeature?.length === 0)
      getMissingFeature(downgradePlan);
  }, [downgradePlan, billingCycle]);

  const handleDowngradeBeforeModal = () => {
    const list = filterOutMissingFeatureList(missingFeature);
    return (
      <InfoDialogUI
        size="lg"
        show={true}
        title=""
        onClose={closeDowngradeModal}
        preventClose={loading}>
        <div>
          <h3
            style={{
              margin: '0 0 8px',
              fontWeight: 700,
              fontSize: '24px',
              lineHeight: '120%',
              textAlign: 'center',
              letterSpacing: '0.01em',
              color: '#202020',
            }}>
            Before you go, {currentUser?.user?.name}
          </h3>
          {list && list?.length > 0 ? (
            <>
              <p
                style={{
                  margin: '0 0 24px',
                  fontWeight: 500,
                  fontSize: '15px',
                  lineHeight: '120%',
                  textAlign: 'center',
                  letterSpacing: '0.01em',
                  color: '#202020',
                }}>
                By downgrading to {downgradePlan?.name}, your team will loose access to the
                following:
              </p>
              <div className="ms-5" style={{ margin: '0 0 20px' }}>
                {list?.map((list, index) => {
                  return (
                    <p
                      className="d-flex align-items-center gap-2"
                      style={{
                        margin: '0 0 4px',
                        fontWeight: '500',
                        fontSize: '15px',
                        lineHeight: '120%',
                        letterSpacing: '0.01em',
                        color: '#202020',
                      }}
                      key={index}>
                      {' '}
                      <CloseIcon style={{ width: 12, height: 12 }} />{' '}
                      {list?.product_name || list?.name} (
                      {(list?.missing_quantity &&
                        list?.missing_quantity?.toString()?.replace('-', '')) ||
                        0}
                      )
                    </p>
                  );
                })}
              </div>
            </>
          ) : (
            <p
              style={{
                margin: '0 0 24px',
                fontWeight: 500,
                fontSize: '15px',
                lineHeight: '120%',
                textAlign: 'center',
                letterSpacing: '0.01em',
                color: '#202020',
              }}>
              Are you sure you wan to downgrade to {downgradePlan?.name?.replace('Plan', '')}{' '}
              {billingCycle === RECURRING_INTERVAL.MONTH ? 'monthly' : 'yearly'} plan?
            </p>
          )}
          <Loader loading={featureLoading} position="absolute" backdrop />

          <Button size="xlg" className="w-100" onClick={closeDowngradeModal}>
            <span className="text-white">I changed my mind, take me back</span>
          </Button>

          <hr style={{ margin: '2rem auto', background: '#000' }} />

          <div className="downgradeModelActionBtn">
            <div className="w-100">
              <p
                style={{
                  margin: '0 0 12px',
                  fontWeight: 500,
                  fontSize: '15px',
                  lineHeight: '120%',
                  textAlign: 'center',
                  letterSpacing: '0.01em',
                  color: '#202020',
                }}>
                Have a question?
              </p>
              <Button size="xlg" className="flex-fill w-100" onClick={contactSupport}>
                <span className="text-white">Contact support</span>
              </Button>
            </div>
            <div className="w-100">
              <Button
                size="xlg"
                className="flex-fill w-100"
                style={{
                  color: 'var(--dark-color)',
                  background: '#CACACA',
                  borderColor: '#CACACA',
                }}
                loading={loading}
                onClick={() => setShowWhyDowngradingModal(true)}>
                I still want to downgrade
              </Button>
            </div>
          </div>
        </div>
      </InfoDialogUI>
    );
  };

  const handlePaymentSuccessModal = () => {
    let downgradDetailsPlan = '';
    let downgradPlanName = '';
    const isCreatorPlan = selectIsCreatorPlan(getAppState());
    if (isPlanDowngraded) {
      const _recurringInterval = billingCycle;
      downgradDetailsPlan = downgradePlan?.pricing_details?.find(
        (a) => a?.recurring_interval === +_recurringInterval
      );
      downgradPlanName = downgradDetailsPlan?.nickname || downgradePlan?.name;
    }

    const heading =
      (isPlanUpgraded && (isBankDefaultPM ? 'Payment initiated' : 'Payment successful!')) ||
      (isPlanDowngraded && 'Downgrade successful') ||
      '';
    const activePlanName = checkoutInfo?.name; // || upgradePlanInfo?.name;
    const expiresOn = getDateFromTimestamp(activePlan?.current_period_end_timestamp, true);
    const description = isCreatorPlan
      ? 'Your plan has been upgraded, and the additional limit have been successfully added to your account.'
      : (isPlanUpgraded &&
        `Your ${activePlanName?.replace('Plan', '') || ''} ${billingCycle === RECURRING_INTERVAL.MONTH ? '(Monthly)' : '(Yearly)'
        } plan has been activated.`) ||
      (isPlanDowngraded &&
        `You will be downgraded to ${downgradPlanName?.replace(
          'Plan',
          ''
        )} plan on ${expiresOn}.`) ||
      ``;

    if (!heading) return;
    return (
      <SubscriptionStatusModal
        show={true}
        onClose={() => {
          closeDialog();
          navigateToPlans();
        }}
        icon={PaymentDoneIcon}
        heading={heading}
        description={description}
        preventClose={false}
        actions={
          <>
            <Button
              color="primary"
              variant="filled"
              size="xlg"
              onClick={() => {
                // await closeDialog();
                navigateToPlans();
              }}
              className="w-100">
              Ok, great
            </Button>
          </>
        }
      />
    );
  };

  const openModelForAskingWhyDowngrading = () => {
    const handleWhyDowngrading = (value = '') => {
      const why_downgrading = value || downgradingReason || '';
      if (!why_downgrading) return;
      const contactObj = {
        properties: {
          email: currentUser?.user?.email,
          firstname: currentUser?.user?.first_name,
          lastname: removeUndefinedText(currentUser?.user?.last_name),
          why_downgrading: why_downgrading,
        },
      };

      fetch(HUBSPOT_API, {
        method: 'POST',
        body: JSON.stringify(contactObj),
      })
        .then((response) => {
          if (response.ok) {
            handleUpgrade({
              isDowngrading: true,
              skipCard: true,
            });
            return response.json();
          }
          //captureException({...contactObj?.properties, type: "Feedback Form Submit Error"})
          closeDowngradingReasonModal();
          throw new Error('Unable to submit your feedback.');
        })
        .catch(() => {
          //captureException({ ...contactObj?.properties, type: "Feedback Form Submit Error" })
          errorToast('Unable to submit your feedback.');
          closeDowngradingReasonModal();
        });
    };

    return (
      <InfoDialogUI
        size="lg"
        show={true}
        title=""
        onClose={closeDowngradingReasonModal}
        preventClose={loading}>
        <div>
          <h3
            style={{
              margin: '0 0 8px',
              fontWeight: 400,
              fontSize: '24px',
              lineHeight: '120%',
              textAlign: 'center',
              letterSpacing: '0.01em',
              color: '#202020',
            }}>
            {currentUser?.user?.name}, we’re sorry you’re thinking of downgrading. Would you tell us
            why? We might be able to help.
          </h3>

          <ul
            className="d-flex flex-column gap-1"
            style={{
              margin: '24px 0 0',
              padding: 0,
              listStyle: 'none',
            }}>
            {Object.keys(WHY_DOWNGRADING_OPTIONS).map((key, i) => {
              const isSelected = whyDowngrading?.toLowerCase() === key?.toLowerCase();
              return (
                <li
                  key={i}
                  onClick={() => {
                    setWhyDowngrading(key);
                    if (key?.toLowerCase() !== WHY_DOWNGRADING_OPTIONS.OTHER?.toLowerCase())
                      handleWhyDowngrading(WHY_DOWNGRADING_OPTIONS[key]);
                  }}
                  style={{
                    cursor: 'pointer',
                    padding: '16px 24px',
                    color: isSelected ? '#fff' : '#202020',
                    fontSize: '15px',
                    fontStyle: 'normal',
                    fontWeight: '500',
                    lineHeight: '120%',
                    letterSpacing: '0.15px',
                    backgroundColor: isSelected ? 'var(--primary-color)' : '#eee',
                  }}>
                  {WHY_DOWNGRADING_OPTIONS[key]}
                </li>
              );
            })}
            {whyDowngrading?.toLowerCase() === 'other' && (
              <li
                style={{
                  padding: '12px 0 0',
                }}>
                <Input
                  label={false}
                  className={`w-100 my-details-input`} // ${error ? 'input-error' : ''}`}
                  name="text"
                  title="Reason"
                  maskPlaceholder={'Reason for downgrading...'}
                  onChange={(v) => setDowngradingReason(v.value)}
                  required
                  value={downgradingReason}
                  style={{
                    boxShadow: 'none',
                  }}
                  onKeyDown={(e) => {
                    if (e.key !== 'Enter') return;
                    handleWhyDowngrading?.(e.value);
                  }}
                />
              </li>
            )}
          </ul>
        </div>
      </InfoDialogUI>
    );
  };

  const currentPlanIsCancelled = () => {
    const creatorPlanBaseTypes = [
      TEXTURE_BASE_TYPE,
      THREE_3D_MODAL_BASE_TYPE,
      ADD_ONS_PRODUCT_BASE_NAME.Editor,
    ];

    const activePlans = userPlans.filter(
      ({ is_cancelled, status }) => !is_cancelled && status !== 'deleted'
    );

    for (const plan of activePlans) {
      for (const priceInfo of plan?.plan_details || []) {
        if (creatorPlanBaseTypes.includes(priceInfo?.basemodeltype)) {
          const shouldRestore =
            +priceInfo?.to_remove_product_quantity > 0 && +priceInfo?.product_quantity === 0;

          if (shouldRestore) {
            return true;
          }
        }
      }
    }
    return false;
  };

  const handleRestorePlan = async () => {
    const creatorPlanBaseTypes = [
      TEXTURE_BASE_TYPE,
      THREE_3D_MODAL_BASE_TYPE,
      ADD_ONS_PRODUCT_BASE_NAME.Editor,
    ];

    const activePlans = userPlans.filter(
      ({ is_cancelled, status }) => !is_cancelled && status !== 'deleted'
    );

    const monthlyPayload = [];
    const yearlyPayload = [];
    let subscriptionMonthId = null;
    let subscriptionYearlyId = null;

    const payload = {
      cancel_downgrade: true,
      data: [],
    };

    // Helper function to process priceInfo
    const processPriceInfo = (plan, priceInfo) => {
      if (creatorPlanBaseTypes.includes(priceInfo?.basemodeltype)) {
        const shouldRestore =
          +priceInfo?.to_remove_product_quantity > 0 && +priceInfo?.product_quantity === 0;

        if (shouldRestore) {
          const { recurring_interval, id } = plan;
          const { price_stripe_price_id } = priceInfo;

          if (+recurring_interval === RECURRING_INTERVAL.MONTH) {
            monthlyPayload.push(price_stripe_price_id);
            subscriptionMonthId = id;
          } else {
            yearlyPayload.push(price_stripe_price_id);
            subscriptionYearlyId = id;
          }
        }
      }
    };

    // Process active plans
    for (const plan of activePlans) {
      for (const priceInfo of plan?.plan_details || []) {
        processPriceInfo(plan, priceInfo);
      }
    }
    // Helper function to handle API call
    const handlePlanUpgrade = async (payloadData, subscriptionId) => {
      payload.data = payloadData;
      setRestorePlanLoading(true)
      const response = await UpgradeToNewPlanPatchV2(payload, subscriptionId);
      setRestorePlanLoading(false)
      return response;
    };

    let res = null;

    if (monthlyPayload.length && subscriptionMonthId) {
      res = await handlePlanUpgrade(monthlyPayload, subscriptionMonthId);
    }

    if (yearlyPayload.length && subscriptionYearlyId) {
      res = await handlePlanUpgrade(yearlyPayload, subscriptionYearlyId);
    }

    if (res) {
      closeInfoDialog();
      dispatch(setClientSubscriptionPlans());
      dispatch(setFailedClientSubscriptionPlansAndAddOnsV2());
    }
  };

  return {
    isMattressBuilderPurchased,

    activePlanName,
    userPlans,
    uploadLimitPlan,
    purchasedUploadLimitPlan,

    checkoutInfo,
    setCheckoutInfo,

    billingCycle,
    setBillingCycle,

    downgradePlan,
    setDowngradePlan,

    loading,

    handlePurchasePlan: handleUpgrade,
    handlePurchasePlanV2: handleUpgradeV2,
    handlePurchasePlanAndAddons: handleUpgradeV3,
    handleCancelPlan,
    handleCancelPlanV2,

    missingFeature,

    handleDowngradeBeforeModal,
    handlePaymentSuccessModal,
    openModelForAskingWhyDowngrading,

    showWhyDowngradingModal,

    getMissingFeature,

    pricingDetails,
    setPricingDetails,
    originPrices,
    setOriginPrices,
    sliderValues,
    setSliderValues,
    currentPlanIsCancelled,
    handleRestorePlan,
    restorePlanLoading,
    imagineCreditLimit,
    getImagineCreditInfo
  };
}
